import config from 'src/config';

function AcceptTermsModalCtrl($scope, $uibModalInstance, managementUserService, alertService, sdkUtils) {
  $scope.saving = false;
  $scope.termsUrl = config.TERMS_URL;

  $scope.close = function () {
    $uibModalInstance.close(false);
  };

  $scope.confirm = function () {
    $scope.saving = true;

    return managementUserService.updateMe({
        acceptedTerms: true
      })
      .then(updatedUser => {
        managementUserService.setCurrentUser(updatedUser);

        $scope.close();
      })
      .catch(error => alertService.error(sdkUtils.getErrorFromResponse(error)));
  };
}

AcceptTermsModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'jsSdk.managementUser',
  'alertService',
  'jsSdk.utils'
];

export default AcceptTermsModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/acceptTerms/controller.js